import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IntegrationsApiService } from '@recruitee/integrations-http';

import type {
  FieldMapping,
  FieldMappingCreateParams,
  UpdateFieldMappingsPositionsParams,
} from '../../../types';

@Injectable({ providedIn: 'root' })
export class FieldMappingHttpClient {
  constructor(private httpClient: IntegrationsApiService) {}

  public createFieldMappings(
    integrationKind: string,
    formConfigId: number,
    params: FieldMappingCreateParams,
  ): Observable<FieldMapping[]> {
    return this.httpClient
      .post(
        `/field-mapping/i/${integrationKind}/form-configs/${formConfigId}/field-mappings`,
        params,
      )
      .pipe(map(({ fieldMappings }: { fieldMappings: FieldMapping[] }) => fieldMappings));
  }

  public deleteFieldMapping(integrationKind: string, fieldMappingId: number): Observable<any> {
    return this.httpClient.delete(
      `/field-mapping/i/${integrationKind}/field-mappings/${fieldMappingId}`,
    );
  }

  public updateFieldMappingsPositions(
    integrationKind: string,
    formConfigId: number,
    params: UpdateFieldMappingsPositionsParams,
  ): Observable<any> {
    return this.httpClient.patch(
      `field-mapping/i/${integrationKind}/form-configs/${formConfigId}/update-positions`,
      params,
    );
  }
}
